class FlashMessage {

    constructor(period) {
        this.elFlash = document.querySelector('.flash-message-holder');
        if (this.elFlash) {
            setInterval(this.flashTick, 1000);
            this.elFlash.dataset.timer = period;
        }
    }

    flashTick() {
        const elMessages = document.getElementsByClassName('flash-message');
        Array.from(elMessages).forEach(function(el) {
            if (parseInt(el.dataset.timer) === 0) {
                el.dataset.timer = el.dataset.initTimer;
                el.classList.remove('is-showing');
                el.addEventListener('transitionend', function () { this.remove() });
            } else {
                el.dataset.timer = parseInt(el.dataset.timer) - 1;
            }
        });
    }

    add(text, icon = null) {
        const elFlash = document.querySelector('.flash-message-holder');

        let elMessage = document.createElement("div");
        elMessage.classList.add('flash-message', 'is-showing');
        elMessage.dataset.timer = this.elFlash.dataset.timer;
        let iconHtml = !icon? '' : `<img src="/images/icons/${icon}.svg" alt=""></div>`;
        elMessage.innerHTML = `<div class="image">${iconHtml}<div class="text">${text}</div>`;
        elFlash.appendChild(elMessage);
    }

}

export default FlashMessage;
